import Immutable from 'seamless-immutable'

export interface State {
  data: Object
}

const model: State = {
  data: {},
}

export const initialState = Immutable.from(model)
